'use strict';

module.exports = function tap(fn) {
  fn(this);
  return this;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/tap.js
// module id = 1277
// module chunks = 2